import { render, staticRenderFns } from "./loginWX.vue?vue&type=template&id=4b16b430&scoped=true&"
import script from "./loginWX.vue?vue&type=script&lang=js&"
export * from "./loginWX.vue?vue&type=script&lang=js&"
import style0 from "./loginWX.vue?vue&type=style&index=0&id=4b16b430&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b16b430",
  null
  
)

export default component.exports